import {
  IonList,
  IonListHeader,
} from '@ionic/react';
import React, { useRef, useEffect } from 'react';
import { KoStore } from '../models/KoStore';
import KoStoreListItem from './KoStoreListItem';

interface OwnProps {
  kostores: KoStore[];
  highlightOrderNum?: number;
}

interface StateProps {
}

interface KoStoreListProps extends OwnProps, StateProps {}

const KoStoreList: React.FC<KoStoreListProps> = ({
  kostores,
  highlightOrderNum
}) => {
  const kostoreListRef = useRef<HTMLIonListElement>(null);

  useEffect(() => {
    if (kostoreListRef.current) {
      kostoreListRef.current.closeSlidingItems();
    }
  }, []);

  if (kostores.length === 0) {
    return (
      <IonList>
        <IonListHeader>データがありません。</IonListHeader>
      </IonList>
    );
  }

  return (
    <>
      <IonList ref={kostoreListRef}>
        {kostores.map((record, index: number) => (
          <KoStoreListItem
            key={`record-${index}`}
            kostore={record}
            highlightOrderNum={highlightOrderNum}
          />
        ))}
      </IonList>
    </>
  );
};

export default KoStoreList;
